import React from "react";
import "../admin-actions/styles.css";
import Text from "../typography/text";
import Button from "../button/button";
import { useLocation } from "react-router-dom";
import { hasPermission } from "../../Config/permissions.js";

const AdminActions = ({
  firstButtonText,
  firstButtonType,
  firstButtonFn,
  secondButtonText,
  secondButtonType,
  secondButtonFn,
  thirdButtonText,
  thirdButtonType,
  thirdButtonFn,
  fourthButtonText,
  fourthButtonType,
  fourthButtonFn,
  fourthButtonCondition,
  fifthButtonText,
  fifthButtonType,
  fifthButtonFn,
  fifthButtonCondition,
  sixthButtonText,
  sixthButtonType,
  sixthButtonFn,
  seventhButtonText,
  seventhButtonType,
  seventhButtonFn,
  eighthButtonText,
  eighthButtonType,
  eighthButtonFn,
  contractRightsButtonText,
  contractRightsButtonType,
  contractRightsButtonFn,
  contractRightsButtonCondition,
  commissionAppliedCondition,
  commissionFullyAppliedCondition,
  isVoidedInvoiceCondition,
  userData,
  invoiceData,
  ivrComponent,
  applyCommissionDisable, // change the name later of this as it used in Distribtor also
  isSuperAdmin
}) => {
  const location = useLocation();
  const IVRPath = location.pathname.startsWith("/IVRDetails/") || location.pathname.startsWith("/IVRProduct/");

  return (
    <div className="admin-container">
      <Text variant="bodyText" color="darkText">
        Admin Actions
      </Text>
      {IVRPath ? (
        <div className="actions-container" >
          <div className="ivr-actions-child-container">
            <div className="ivr-actions-button-group">
              {firstButtonText && firstButtonFn && (
                <Button
                  variant="table"
                  subVariant={firstButtonType}
                  style={{ minWidth: "100px" }}
                  onClick={firstButtonFn}
                >
                  {firstButtonText}
                </Button>
              )}
              {secondButtonText && secondButtonFn && (
                <Button
                  variant="table"
                  subVariant={secondButtonType}
                  style={{ minWidth: "100px" }}
                  onClick={secondButtonFn}
                >
                  {secondButtonText}
                </Button>
              )}
              {isSuperAdmin && thirdButtonText && thirdButtonFn && (
                <Button
                  variant="table"
                  subVariant={thirdButtonType}
                  style={{ minWidth: "100px" }}
                  onClick={thirdButtonFn}
                >
                  {thirdButtonText}
                </Button>
              )}
              {fourthButtonCondition && fourthButtonText && fourthButtonFn && (
                <Button
                  variant="table"
                  subVariant={fourthButtonType}
                  style={{ minWidth: "100px" }}
                  onClick={fourthButtonFn}
                >
                  {fourthButtonText}
                </Button>
              )}
            </div>
            {ivrComponent}
            { }
            {/* <Divider type="vertical" />
            <div className="ivr-actions-activity-box-container">
              <Text variant="smallText">IVR details were downloaded</Text>
              <div className="ivr-actions-activity-timestamp-container">
                <Text variant="tinyText" color="lightText">
                  03-09-2026
                </Text>
                <Text variant="tinyText" color="lightText">
                  By UserName
                </Text>
              </div>
            </div> */}

            {/* <Button
              variant="table"
              subVariant={fourthButtonType}
              style={{ minWidth: "100px" }}
              onClick={fourthButtonFn}
              disabled={applyCommissionDisable}
            >
              {fourthButtonText}
            </Button>

            <Button
              variant="table"
              subVariant={fifthButtonType}
              style={{ minWidth: "100px" }}
              onClick={fifthButtonFn}
            >
              {fifthButtonText}
            </Button> */}
          </div>
        </div>
      ) : (
        <div className="actions-container">
          {isVoidedInvoiceCondition ? (
            <Button
              variant="table"
              subVariant={firstButtonType}
              style={{ minWidth: "100px" }}
              onClick={firstButtonFn}
            >
              {firstButtonText}
            </Button>
          ) : (
            <>
              <Button
                variant="table"
                subVariant={firstButtonType}
                style={{ minWidth: "100px" }}
                onClick={firstButtonFn}
              >
                {firstButtonText}
              </Button>
              {!commissionAppliedCondition && (
                <Button
                  variant="table"
                  subVariant={secondButtonType}
                  style={{ minWidth: "100px" }}
                  onClick={secondButtonFn}
                >
                  {secondButtonText}
                </Button>
              )}
              {!commissionFullyAppliedCondition ? (
                <>
                  <Button
                    variant="table"
                    subVariant={thirdButtonType}
                    style={{ minWidth: "100px" }}
                    onClick={thirdButtonFn}
                    disabled={applyCommissionDisable}
                  >
                    {thirdButtonText}
                  </Button>

                  <Button
                    variant="table"
                    subVariant={fourthButtonType}
                    style={{ minWidth: "100px" }}
                    onClick={fourthButtonFn}
                    disabled={applyCommissionDisable}
                  >
                    {fourthButtonText}
                  </Button>
                </>
              ) : null}
              {contractRightsButtonCondition &&
                contractRightsButtonType &&
                contractRightsButtonText &&
                contractRightsButtonFn && (
                  <Button
                    variant="table"
                    subVariant={contractRightsButtonType}
                    style={{ minWidth: "100px" }}
                    onClick={contractRightsButtonFn}
                  >
                    {contractRightsButtonText}
                  </Button>
                )}
              {fifthButtonType &&
                (fifthButtonCondition ??
                  (invoiceData?.FullyPaidDate === null)) && (
                <Button
                  variant="table"
                  subVariant={fifthButtonType}
                  style={{ minWidth: "100px" }}
                  onClick={fifthButtonFn}
                >
                  {fifthButtonText}
                </Button>
                )}
              {commissionAppliedCondition &&
                !invoiceData.IsStatementGenerated &&
                hasPermission(userData, "commission.reset") &&
                sixthButtonType && (
                  <Button
                    variant="table"
                    subVariant={sixthButtonType}
                    style={{ minWidth: "100px" }}
                    onClick={sixthButtonFn}
                  >
                    {sixthButtonText}
                  </Button>
                )}
              {seventhButtonType &&
                userData.Type === "Admin" &&
                userData.IsSuperAdmin &&
                !commissionAppliedCondition && (
                  <Button
                    variant="table"
                    subVariant={seventhButtonType}
                    style={{ minWidth: "100px" }}
                    onClick={seventhButtonFn}
                  >
                    {seventhButtonText}
                  </Button>
                )}
              {eighthButtonType && (
                <Button
                  variant="table"
                  subVariant={eighthButtonType}
                  style={{ minWidth: "100px" }}
                  onClick={eighthButtonFn}
                >
                  {eighthButtonText}
                </Button>
              )}
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default AdminActions;
